import config from 'config'

const CHENGZI8_LOGO = 'https://www.ichengzi8.com/logo.png'
const CANVOPIX_LOGO = 'https://www.canvopix.com/canvopix_logo.png'

export const getBrand = (): 'canvopix' | '橙子8' => {
  return (config?.brand as string).toLowerCase() as any || '橙子8'
}

export const getRegion = () => config.region || 'cn'

export const getBrandConfig = () => {
  const brand = getBrand()
  return {
    brand: config.brand || '橙子8',
    showRuler: brand === '橙子8',
    brandColor: brand === '橙子8' ? '#FF5757' : '#8b3dff',
    brandLogo: brand === '橙子8' ? CHENGZI8_LOGO : CANVOPIX_LOGO,
  }
}